import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ModuleChartMultiView from "../../components/chartMultiView";
import ProjectAPI from "../../axios/api/project";
import { setUser } from "../../redux/slice/user";
import { setToast } from "../../redux/slice/system";

export default function FrontIframeMultiChart() {
  const route_params = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const redux_user = useSelector((state) => state.user);
  const apiKey = searchParams.get("apiKey");
  const [authStatus, setAuthStatus] = useState("pending"); // pending | success | failed

  useEffect(() => {
    if (redux_user.data?.token) return;

    ProjectAPI.authVerify({
      data: {
        mappingURLID: route_params.detailid,
        apiKey,
      },
      settings: { skipAuthRedirect: true },
    }).then((result) => {
      if (result.Response === 1 && result.data) {
        dispatch(setUser(result));
        setTimeout(() => {
          setAuthStatus("success");
        }, 100);
      } else {
        setAuthStatus("failed");
        dispatch(
          setToast({
            severity: "error",
            summary: "授權失敗",
            detail: "授權碼已過期或無效，請重新取得",
          }),
        );
      }
    });
  }, [apiKey, dispatch, redux_user.data?.token, route_params.detailid]);

  return (
    <>
      <div className="w-full h-full p-2">
        {authStatus === "success" && (
          <ModuleChartMultiView mappingURLID={route_params.detailid} />
        )}
        {authStatus === "pending" && (
          <div className="flex items-center justify-center h-full">
            <span>驗證中...</span>
          </div>
        )}
        {authStatus === "failed" && (
          <div className="flex items-center justify-center h-full">
            <span>授權驗證失敗，無法載入內容</span>
          </div>
        )}
      </div>
    </>
  );
}
